import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import { PM_PROVIDERS } from 'common/constants/constants';
import { useSelector } from 'react-redux';
import { isTeamLicenseSelector } from 'state/selectors/license';

const useProjectProgressionPermissions = () => {
  const isTeamLicense = useSelector(isTeamLicenseSelector);

  const permissions = {
    ...(isTeamLicense
      ? {}
      : {
          pmProviders: [PM_PROVIDERS.JIRA, PM_PROVIDERS.AZURE_BOARDS],
          accountTypes: [
            ACCOUNT_TYPES_MAP.Primary,
            ACCOUNT_TYPES_MAP.SuperUser,
            ACCOUNT_TYPES_MAP.Editor,
            ACCOUNT_TYPES_MAP.Viewer
          ]
        })
  };

  return permissions;
};

export default useProjectProgressionPermissions;
